import type { ReactNode } from "react";
import {
  ScrollView,
  StyleSheet,
  useWindowDimensions,
  View,
} from "react-native";

import { spacing } from "~/styles/theme";

export function HorizontalScrollRow({ children }: { children: ReactNode }) {
  const { width } = useWindowDimensions();
  if (width >= 768) return <View style={stylesheet.wrap}>{children}</View>;
  return (
    <ScrollView horizontal showsHorizontalScrollIndicator={false}>
      <View style={stylesheet.scroll}>{children}</View>
    </ScrollView>
  );
}

const stylesheet = StyleSheet.create({
  wrap: {
    flexDirection: "row",
    flexWrap: "wrap",
    alignItems: "center",
    gap: spacing.s,
  },
  scroll: {
    flexDirection: "row",
    alignItems: "center",
    gap: spacing.s,
    paddingRight: spacing.s,
  },
});
